var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"80%","height":"410px","margin":"20px auto"},attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }